// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AD_INTERSCROLLER_END_MSG = "KONIEC REKLAMY";
export const AD_INTERSCROLLER_START_MSG = "REKLAMA";
